<div [class]="merge('stepperControls sc bg-[var(--bk-panel)] py-4', containerClass)">
  <!-- button container -->
  <div
    [class]="
      merge(
        'buttonContainer maximum-width mx-auto flex items-center justify-between gap-3',
        controlContainerClass
      )
    "
  >
    <customizable-button
      [title]="leftButtonLabel"
      [outline]="true"
      [className]="leftButtonClass"
      [disabled]="leftButtonDisabled"
      (click)="leftClick()"
    />
    <customizable-button
      [title]="rightButtonLabel"
      [className]="rightButtonClass"
      [disabled]="rightButtonDisabled"
      [loading]="loading"
      (click)="rightClick()"
    />
  </div>
</div>
